import { flatten } from 'lodash';
import { DateTime } from 'luxon';
var HOURS = 24;
var INTERVALS_PER_HOUR = 4;
var MINUTES_IN_HOUR = 60;
var getTimes = function (hours, intervals) {
    if (hours === void 0) { hours = HOURS; }
    if (intervals === void 0) { intervals = INTERVALS_PER_HOUR; }
    return Array.from(Array(hours).keys()).map(function (hourKey) {
        var intervalLength = getIntervalLength();
        return Array.from(Array(intervals).keys()).map(function (intervalKey) {
            var interval = intervalKey * intervalLength;
            var padded = interval === 0 ? '0' : '';
            return "".concat(hourKey, ":").concat(intervalKey * intervalLength).concat(padded);
        });
    });
};
var getIndexFromTimeString = function (time) {
    if (time) {
        var timeIndex = PICKER_TIMES.findIndex(function (timeMeta) { return timeMeta.time === time; });
        if (PICKER_TIMES[timeIndex]) {
            return timeIndex;
        }
    }
    return undefined;
};
var getIntervalLength = function (minutes, intervals) {
    if (minutes === void 0) { minutes = MINUTES_IN_HOUR; }
    if (intervals === void 0) { intervals = INTERVALS_PER_HOUR; }
    return minutes / intervals;
};
var flattenedTimes = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return flatten(getTimes.apply(void 0, args));
};
var getTime = function (time) { return DateTime.fromFormat(time, 'T'); };
var transformTimeToReadable = function (time) { return getTime(time).toFormat('t'); };
var getMetaFromTimeString = function (time) { return ({
    dateTime: getTime(time),
    label: transformTimeToReadable(time),
    time: time,
}); };
var getTimePickerTimes = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return flattenedTimes.apply(void 0, args).map(getMetaFromTimeString);
};
var PICKER_TIMES = getTimePickerTimes();
var cutoffCompareFactory = function (isUntil) {
    return function (value, index) {
        var currentValueIndex = PICKER_TIMES.findIndex(function (time) { return time.time === value; });
        var comparison = isUntil ? index > currentValueIndex : index < currentValueIndex;
        if (comparison) {
            return PICKER_TIMES[index].time;
        }
        return value;
    };
};
var getCutoffUntil = cutoffCompareFactory(true);
var getCutoffAfter = cutoffCompareFactory(false);
var getTimeStringFromDateTime = function (date) {
    var minute = date.minute, hour = date.hour;
    var padded = minute === 0 ? '0' : '';
    return "".concat(hour, ":").concat(minute).concat(padded);
};
export { getIndexFromTimeString, getCutoffAfter, getCutoffUntil, PICKER_TIMES, INTERVALS_PER_HOUR, transformTimeToReadable, getTimeStringFromDateTime, };
